import React from 'react';
import { Button, Heading, Image } from '@doist/marketist';
import { useTranslation } from 'next-i18next';
import css from './prefooter.module.css';
const suggestLink = 'https://doist.typeform.com/to/NpNQ9WMm';
function Prefooter() {
  const {
    t
  } = useTranslation('templates');
  return <section className={css.prefooterContainer} data-sentry-component="Prefooter" data-sentry-source-file="prefooter.tsx">
            <div className={css.prefooter}>
                <Image className={css.illustration} src={`${process.env.NEXT_PUBLIC_BASE_URL}/static/templates/prefooter@2x.png`} width={178} height={174} alt="" data-sentry-element="Image" data-sentry-source-file="prefooter.tsx" />
                <Heading level="2" size="major-base" data-sentry-element="Heading" data-sentry-source-file="prefooter.tsx">
                    {t('suggestATemplateHeader')}
                </Heading>
                <Heading level="3" size="body-base" weight="medium" data-sentry-element="Heading" data-sentry-source-file="prefooter.tsx">
                    {t('suggestATemplateDescription')}
                </Heading>
                <Button target="_blank" rel="noopener" href={suggestLink} data-sentry-element="Button" data-sentry-source-file="prefooter.tsx">
                    {t('suggestATemplateButton')}
                </Button>
            </div>
        </section>;
}
export { Prefooter };